import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

const AnimateOnScroll = ({
  children,
  animationType = "fade",
  delay = 0,
  imagesLoaded = true,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.1 });

  const variants = {
    fade: {
      hidden: { opacity: 0 },
      visible: { opacity: 1 },
    },
    slideUp: {
      hidden: { opacity: 0, y: 50 },
      visible: { opacity: 1, y: 0 },
    },
    slideLeft: {
      hidden: { opacity: 0, x: -50 },
      visible: { opacity: 1, x: 0 },
    },
    slideRight: {
      hidden: { opacity: 0, x: 50 },
      visible: { opacity: 1, x: 0 },
    },
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={isInView && imagesLoaded ? "visible" : "hidden"}
      variants={variants[animationType]}
      transition={{ duration: 0.8, delay: 0.3 }}
    >
      {children}
    </motion.div>
  );
};

export default AnimateOnScroll;
